export default __webpack_public_path__ + "static/media/tech.206b1cad.svg";